module.exports = __webpack_public_path__ + "img/happy-icon.836e4c77.png";